import { Component, computed, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MultiSelectDropdownComponent } from '@cumlaude/shared-components-inputs';
import { MatchCard } from '../types/match.card';
import { MatchColumn } from '../types/match.column';
import { SelectionChanged } from '../types/selection.changed';

@Component({
	selector: 'app-instelling-migratie-match-secties',
	templateUrl: './instelling-migratie-match-secties.component.html',
	styleUrls: ['./instelling-migratie-match-secties.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MultiSelectDropdownComponent],
})
export class InstellingMigratieMatchSectiesComponent<T> {
	titel = input.required<string>();
	unmatchedCount = input<number>(0);
	unmatchedLabel = input.required<string>();
	autoCards = input<MatchCard<T>[]>([]);
	manualCards = input<MatchCard<T>[]>([]);
	placeholder = input.required<string>();
	emptyAutoMatchesText = input.required<string>();
	emptyManualMatchesText = input.required<string>();
	emptyText = input.required<string>();

	selectionChanged = output<SelectionChanged<T>>();

	columns = computed<MatchColumn<T>[]>(() => [
		{
			title: 'Met automatische match',
			cards: this.autoCards(),
			emptyText: this.emptyAutoMatchesText(),
		},
		{
			title: 'Handmatig matchen',
			cards: this.manualCards(),
			emptyText: this.emptyManualMatchesText(),
		},
	]);

	hasCards = computed(() => this.autoCards().length + this.manualCards().length > 0);

	onSelectionChanged(matchIndex: number, selection: T[]): void {
		this.selectionChanged.emit({ matchIndex, selection });
	}
}
